import * as ActionTypes from './actionTypes'
import {
  saveShipmentDetail,
  addAIInfo,
  addAddInfo,
  saveAIStatementAndCodesInfo,
} from '../api/saveC88Data'
import { deleteAIStatementAndCodeInfoHeader } from '../api/deleteC88Data'
import { showToast } from '../../commonComponents/showToast'
import { HttpClient } from '../../../commonApis/httpClient'

export const updateShipmentFieldValue = (payload) => {
  return {
    type: ActionTypes.UPDATE_SHIPMENT_FIELD_VALUE,
    payload,
  }
}

export function updateHeaderAIStatementInfoFeilds(infoIndex, infoField, payload) {
  return {
    type: ActionTypes.UPDATE_AI_STATEMENT_INFO_FIELDS,
    payload,
    infoIndex,
    infoField,
  }
}

export function createAdditonalInfo(addInfoStatus) {
  return (dispatch, getState) => {
    let dataSent = addAddInfo()
    HttpClient.post(dataSent)
      .then((response) => {
        if (response.data.eventMessage.code !== 400) {
          let payload = response.data.eventMessage
          dispatch({
            type: ActionTypes.ADD_ADDITONAL_INFO,
            payload,
          })
        }
        addInfoStatus()
      })
      .catch((error) => {
        console.log('ERROR:: ' + error)
        showToast('Something went wrong, Check your network connection!')
        addInfoStatus()
      })
  }
}

export function createAICodeAndStatementnfo(addInfoStatus) {
  return (dispatch, getState) => {
    let dataSent = addAIInfo()
    HttpClient.post(dataSent)
      .then((response) => {
        if (response.data.eventMessage.code !== 400) {
          let payload = response.data.eventMessage
          dispatch({
            type: ActionTypes.ADD_AI_CODES_AND_STATEMENT_INFO,
            payload,
          })
        }
        addInfoStatus()
      })
      .catch((error) => {
        console.log('ERROR:: ' + error)
        showToast('Something went wrong, Check your network connection!')
        addInfoStatus()
      })
  }
}

// clear form
export const clearForm = () => {
  return {
    type: ActionTypes.CLEAR_FORM,
  }
}
// initialize Header Form

export const initializeHeaderForm = (payload) => {
  return {
    type: ActionTypes.INITIALIZE_HEADER_FORM,
    payload,
  }
}

export function saveShipmentFieldValue(fieldName, val = '') {
  return (dispatch, getState) => {
    console.log(getState().Shipment)
    let fieldValue =
      (fieldName === 'shipmentValue' || fieldName === 'totalShipmentPackages') &&
      getState().Shipment[fieldName] === ''
        ? '-999'
        : getState().Shipment[fieldName] === ''
        ? '_BLANK_'
        : getState().Shipment[fieldName]
    console.log(fieldValue, 'fieldValue')

    saveShipmentDetail(fieldName, fieldValue).then((response) => {
      if (fieldName === 'shipmentValueCurrency') {
        if (response.hasOwnProperty('invoices') === true) {
        } else if (response.data.eventMessage.hasOwnProperty('code') === true) {
          showToast(response.data.eventMessage.msg)
        }
      }
    })
  }
}

// transportation start

export const updateTransportationDetails = ({ key, payload }) => {
  return {
    type: ActionTypes.UPDATE_TRANSPORT_DETAILS,
    key,
    payload,
  }
}
export const updateTransportationHeaderInfo = (payload) => {
  return {
    type: ActionTypes.UPDATE_TRANSPORT_HEADER_INFO,
    payload,
  }
}
export const updatearrivalTransportField = (payload) => {
  return {
    type: ActionTypes.UPDATE_ARRIVAL_TRANSPORT_FIELDS,
    payload,
  }
}
export const updatedeliveryTransportField = (payload) => {
  return {
    type: ActionTypes.UPDATE_DELIVERY_TRANSPORT_FIELDS,
    payload,
  }
}
// transportation end

export function saveAIInfoFeilds(infoIndex, fieldName) {
  return (dispatch, getState) => {
    let lineItemInfo = getState().Shipment.aiStatementUkInfo[infoIndex]
    let fieldValue = lineItemInfo[fieldName] === '' ? '_BLANK_' : lineItemInfo[fieldName]
    let response = saveAIStatementAndCodesInfo(lineItemInfo.infoId, fieldName, fieldValue)
    console.log(response)
  }
}

// containers start

export function createContainerHeader(addInfoStatus) {
  return (dispatch, getState) => {
    let dataSent = addAIInfo()
    HttpClient.post(dataSent)
      .then((response) => {
        if (response.data.eventMessage.code !== 400) {
          let payload = {
            containerNo: '',
            seal: '',
            qty: '',
            weight: '',
            size: '',
            infoId: response.data.eventMessage.infoId,
          }
          dispatch({
            type: ActionTypes.ADD_ITEM,
            payload,
            meta: { tableName: 'headerContainer' },
          })
        }
        addInfoStatus()
      })
      .catch((error) => {
        console.log('ERROR:: ' + error)
        showToast('Something went wrong, Check your network connection!')
        addInfoStatus()
      })
  }
}
export function deleteContainerHeader(id) {
  return (dispatch, getState) => {
    deleteAIStatementAndCodeInfoHeader(getState().Shipment.shipmentId, id)
      .then((response) => {
        console.log('11111111', id)
        dispatch({
          type: ActionTypes.DELETE_ITEM,
          id,
          meta: { tableName: 'headerContainer' },
        })
      })
      .catch((error) => {
        dispatch({
          type: ActionTypes.DELETE_ITEM,
          id,
          meta: { tableName: 'headerContainer' },
        })
        console.error(`Error in removeLineItemInfo : `, error)
        showToast('Something went wrong, Check your network connection!')
      })
  }
}
export const updateContainerHeader = (id, fieldName, val) => {
  return {
    type: ActionTypes.UPDATE_ITEM,
    id,
    fieldName,
    val,
    meta: { tableName: 'headerContainer' },
  }
}

export const updateEidrEoriNumber = (payload) =>{
  return {
    type:ActionTypes.UPDATE_EIDR_EORI_NUMBER,
    payload:payload
  }

}

// containers end
